{
  "domains": [
    {
      "domain_id": 1347,
      "name": "Subtitling Philippine Airlines (airline: PR)",
      "models": [
        {
          "memory_id": 139801,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zt",
          "trg_locale": "TW",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 141249,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": "CN",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1348,
      "name": "Air Dolomiti",
      "models": [
        {
          "memory_id": 139834,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "it",
          "trg_locale": "IT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139847,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "de",
          "trg_locale": "DE",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1417,
      "name": " Subtitling - TAAG Angola Airlines (airline: TAAG)",
      "models": [
        {
          "memory_id": 142430,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pt",
          "trg_locale": "PT",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1545,
      "name": "Subtitling - Tigerair Taiwan (airline: TTW)",
      "models": [
        {
          "memory_id": 139800,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139801,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zt",
          "trg_locale": "TW",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1037,
      "name": "Air New Zealand",
      "models": [
        {
          "memory_id": 135786,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135787,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": "CN",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139833,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ko",
          "trg_locale": "KR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 142378,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zt",
          "trg_locale": "HK",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1038,
      "name": "Air Transat",
      "models": [
        {
          "memory_id": 135789,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "CA",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 141443,
          "src_lang": "fr",
          "src_locale": "CA",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1039,
      "name": "Batik Air",
      "models": [
        {
          "memory_id": 135790,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "id",
          "trg_locale": "ID",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1040,
      "name": "Delta",
      "models": [
        {
          "memory_id": 139843,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ru",
          "trg_locale": "RU",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139831,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ar",
          "trg_locale": "MSA",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139840,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pt",
          "trg_locale": "BR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139834,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "it",
          "trg_locale": "IT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139832,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139833,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ko",
          "trg_locale": "KR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139845,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "he",
          "trg_locale": "IL",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139844,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "th",
          "trg_locale": "TH",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139846,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": "CN",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139848,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "CA",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139847,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "de",
          "trg_locale": "DE",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139849,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "nl",
          "trg_locale": "NL",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135791,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "MX",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139842,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "hi",
          "trg_locale": "IN",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1041,
      "name": "Embraer",
      "models": [
        {
          "memory_id": 135792,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pt",
          "trg_locale": "BR",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1042,
      "name": "Eurowings",
      "models": [
        {
          "memory_id": 135793,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "de",
          "trg_locale": "DE",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1043,
      "name": "HiFly - 9H SUN",
      "models": [
        {
          "memory_id": 135794,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1044,
      "name": "KF AERO",
      "models": [
        {
          "memory_id": 135799,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "CA",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1045,
      "name": "LATAM",
      "models": [
        {
          "memory_id": 139843,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ru",
          "trg_locale": "RU",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135800,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pt",
          "trg_locale": "BR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139831,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ar",
          "trg_locale": "MSA",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139832,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139833,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ko",
          "trg_locale": "KR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139845,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "he",
          "trg_locale": "IL",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139846,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": "CN",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 140167,
          "src_lang": "pt",
          "src_locale": "BR",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139849,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "nl",
          "trg_locale": "NL",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 141123,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "sv",
          "trg_locale": "SE",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 141732,
          "src_lang": "es",
          "src_locale": "419",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135795,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "it",
          "trg_locale": "IT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135796,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135797,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "CL",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135798,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "de",
          "trg_locale": "DE",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1046,
      "name": "LOT",
      "models": [
        {
          "memory_id": 139843,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ru",
          "trg_locale": "RU",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139831,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ar",
          "trg_locale": "MSA",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135801,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "hu",
          "trg_locale": "HU",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139840,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pt",
          "trg_locale": "BR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135802,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pl",
          "trg_locale": "PL",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139834,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "it",
          "trg_locale": "IT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135803,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ko",
          "trg_locale": "KR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139832,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135804,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139833,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ko",
          "trg_locale": "KR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135805,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "hi",
          "trg_locale": "IN",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135806,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": "CN",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135807,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135808,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "ES",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135809,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "de",
          "trg_locale": "DE",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 138472,
          "src_lang": "pl",
          "src_locale": "PL",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 141260,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "uk",
          "trg_locale": "UA",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139842,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "hi",
          "trg_locale": "IN",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1047,
      "name": "Pelita Air",
      "models": [
        {
          "memory_id": 135810,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "id",
          "trg_locale": "ID",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1048,
      "name": "RAM",
      "models": [
        {
          "memory_id": 139831,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ar",
          "trg_locale": "MSA",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 142377,
          "src_lang": "ar",
          "src_locale": null,
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135812,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139829,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "ES",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139830,
          "src_lang": "fr",
          "src_locale": "FR",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1049,
      "name": "Riyadh Air",
      "models": [
        {
          "memory_id": 139834,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "it",
          "trg_locale": "IT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139846,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": "CN",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 138909,
          "src_lang": "ar",
          "src_locale": null,
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139829,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "ES",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135813,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ar",
          "trg_locale": "SA",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 142339,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1050,
      "name": "RMAF",
      "models": [
        {
          "memory_id": 135814,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1051,
      "name": "SAS",
      "models": [
        {
          "memory_id": 135815,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": "CN",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135816,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136710,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "sv",
          "trg_locale": "SE",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136711,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "da",
          "trg_locale": "DK",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136712,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "no",
          "trg_locale": "NO",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136713,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136714,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ko",
          "trg_locale": "KR",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1052,
      "name": "Super Air Jet",
      "models": [
        {
          "memory_id": 135817,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "id",
          "trg_locale": "ID",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1053,
      "name": "TAAG",
      "models": [
        {
          "memory_id": 135818,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pt",
          "trg_locale": "PT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135819,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139846,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": "CN",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139829,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "ES",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1054,
      "name": "TAP",
      "models": [
        {
          "memory_id": 139783,
          "src_lang": "pt",
          "src_locale": "PT",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135820,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pt",
          "trg_locale": "PT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139783,
          "src_lang": "pt",
          "src_locale": "PT",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1055,
      "name": "Westjet",
      "models": [
        {
          "memory_id": 138883,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 138884,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "CL",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135821,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "CA",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 138885,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": null,
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 138886,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ko",
          "trg_locale": "KR",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1056,
      "name": "AeroMexico",
      "models": [
        {
          "memory_id": 135788,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "MX",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1248,
      "name": "Subtitling - Vietnam Airlines (airline: VN)",
      "models": [
        {
          "memory_id": 139798,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "vi",
          "trg_locale": "VN",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139799,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ko",
          "trg_locale": "KR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139800,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1249,
      "name": "Subtitling China Airlines (airline: CI)",
      "models": [
        {
          "memory_id": 141087,
          "src_lang": "zt",
          "src_locale": null,
          "trg_lang": "zh",
          "trg_locale": null,
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139800,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 139801,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zt",
          "trg_locale": "TW",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 141249,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": "CN",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1122,
      "name": "Subtitling - RAM (airline: AT)",
      "models": [
        {
          "memory_id": 136931,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136934,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "it",
          "trg_locale": "IT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136937,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "de",
          "trg_locale": "DE",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 140577,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ar",
          "trg_locale": "MSA",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1315,
      "name": "Subtitling Egypt Air (airline: MS)",
      "models": [
        {
          "memory_id": 136933,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ar",
          "trg_locale": "MA",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1125,
      "name": "Subtitling - LATAM (airline: LA)",
      "models": [
        {
          "memory_id": 136935,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pt",
          "trg_locale": "BR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136936,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "CL",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 137764,
          "src_lang": "pt",
          "src_locale": "BR",
          "trg_lang": "es",
          "trg_locale": "CL",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136937,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "de",
          "trg_locale": "DE",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 137765,
          "src_lang": "es",
          "src_locale": "CL",
          "trg_lang": "pt",
          "trg_locale": "BR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136938,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136997,
          "src_lang": "pt",
          "src_locale": "BR",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136998,
          "src_lang": "es",
          "src_locale": "419",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1127,
      "name": "Subtitling - LOT (airline: LO)",
      "models": [
        {
          "memory_id": 136939,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pl",
          "trg_locale": "PL",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1128,
      "name": "Subtitling - Delta (airline: DL)",
      "models": [
        {
          "memory_id": 140159,
          "src_lang": "it",
          "src_locale": "IT",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 140160,
          "src_lang": "es",
          "src_locale": "419",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136938,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "en",
          "trg_locale": "US",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1385,
      "name": "Subtitling - AeroMexico",
      "models": [
        {
          "memory_id": 139799,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ko",
          "trg_locale": "KR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 142251,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "419",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1393,
      "name": "HF - Air Cote D'Avoire",
      "models": [
        {
          "memory_id": 142339,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1014,
      "name": "API Test",
      "models": [
        {
          "memory_id": 135237,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "de",
          "trg_locale": "DE",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136206,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ja",
          "trg_locale": "JP",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135238,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "fr",
          "trg_locale": "FR",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135239,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "es",
          "trg_locale": "ES",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135240,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "it",
          "trg_locale": "IT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 135241,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "zh",
          "trg_locale": null,
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136202,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pt",
          "trg_locale": "PT",
          "status": "SUCCESSFULLY_TRAINED"
        },
        {
          "memory_id": 136203,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "pl",
          "trg_locale": "PL",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    },
    {
      "domain_id": 1143,
      "name": "Subtitling - Riyadh Air (airline: RX)",
      "models": [
        {
          "memory_id": 137296,
          "src_lang": "en",
          "src_locale": "US",
          "trg_lang": "ar",
          "trg_locale": "SA",
          "status": "SUCCESSFULLY_TRAINED"
        }
      ]
    }
  ]
}
